import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CommonService } from '../../../_services/common.service';
import { UserService } from '../../../_services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-change-password-modal',
	templateUrl: './change-password-modal.component.html',
	styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {
	@Output() response: EventEmitter<boolean> = new EventEmitter();

	changePasswordForm!: FormGroup;
	loading = false;
	submitted = false;

	private userInfo;

	constructor(private fb: FormBuilder, private commonService: CommonService, private userService: UserService,
		   private dialogRef: MatDialogRef<ChangePasswordModalComponent>,
				   @Inject(MAT_DIALOG_DATA) public data: any 
	) {
		this.userInfo = this.userService.userInfo;
		this.changePasswordForm = this.fb.group({
			oldPassword: [''],
			newPassword: [''],
			confirmNewPassword: ['']
		});
	}

	ngOnInit() { }


	 changePassword() {
    this.submitted = true;

    if (
      this.changePasswordForm.invalid ||
      this.changePasswordForm.get('newPassword')?.value !==
        this.changePasswordForm.get('confirmNewPassword')?.value
    ) {
      return;
    }

    const changePasswordData = {
      ...this.changePasswordForm.value,
      id: this.userInfo.id
    };

    this.userService.changePassword(changePasswordData).subscribe(
      (res: any) => {
        if (res && res.success) {
          this.dialogRef.close({ success: true });
        } else {
          this.commonService.showError('', res.message);
        }
      },
      (err: any) => {
        this.commonService.showError('', err?.error?.message || 'Error occurred');
      }
    );
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
